import { useQuery, useParams } from '@common/hooks';
import React from 'react';
import { ErrorHandler, LoadingState, Navigate } from '@common/components';
import { WorkerIsInternalQuery } from '@scheduling/graphql';

export function WorkerDetailsPage() {
  const { id: workerId } = useParams<{ id: string }>();

  const { loading, data, error } = useQuery(WorkerIsInternalQuery, {
    variables: { id: workerId },
  });

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorHandler error={error} log="WorkerDetailsPage" />;
  }

  return (
    <Navigate
      to={`/works/team/on_demand/${data?.worker.id}/${
        data?.worker.isInternal ? 'units' : 'assignments'
      }`}
    />
  );
}
